const namespaced = true

import api     from '../../api/cid.js';
import _ from 'lodash';

const state = {
    dashboards : [],
}
const mutations = {
     MUTATION_SET_DASHBOARDS(state, value) {
          state.dashboards = value;
     },
     MUTATION_ADD_DASHBOARD(state, value){
          state.dashboards.push(value)
     },
     MUTATION_UPDATE_DASHBOARD(state, value){
          let dashboards = state.dashboards;
          state.dashboards = [];
          _.forEach(dashboards, rol => {
              if(rol.id != value.id){
                  state.dashboards.push(rol);
              }else{
                  state.dashboards.push(value);
              }
          });
     },
     MUTATION_DELETE_DASHBOARD(state, value){
          let dashboards = state.dashboards;
          state.dashboards = [];
          _.forEach(dashboards, rol => {
               if(rol.id != value){
                    state.dashboards.push(rol);
               }
          });
     },
}
const actions = {
     get(context) {
          return new Promise((resolve) => { 
               api.get().then(function (res) {
                    context.commit('MUTATION_SET_DASHBOARDS', res.data);
                    resolve(res.data);
               }).catch(function (error) {
                    console.log(error)
               })
          })
     },
     store(context, data){
          return new Promise((resolve, reject) => {
               api.store(data).then(resp => {
                    context.commit('MUTATION_ADD_DASHBOARD', resp.data);
                    resolve(resp.data);
               }).catch(error => {
                    reject(error);
               });
          });
     },
     update(context, {id, data}){
          return new Promise((resolve, reject) => {
               api.update(id, data).then(resp => {
                    context.commit('MUTATION_UPDATE_DASHBOARD', resp.data);
                    resolve(resp.data);
               }).catch(error => {
                    reject(error);
               });
          });
     },
     delete(context, id){
          return new Promise((resolve, reject) => {
               api.deleted(id).then(resp => {
                    context.commit('MUTATION_DELETE_DASHBOARD', id);
                    resolve(resp.data);
               }).catch(error => {
                    reject(error);
               });
          });
     },
}

const getters = {    

}

export default {
     namespaced,
     state,
     mutations,
     actions,
     getters,
}
